import React, { Component, PropTypes } from "react";
import Sidebar from "./sidebar.js";
import Header from "./header.js";
import Footer from "./footer.js";
import { Routes, Route, Outlet, Link } from "react-router-dom";
import { useClass } from "./../../../contexts/classContext";
const Layout = () => {
  const { myClass } = useClass();
  return (
    <div className={`${myClass}`}>
      <div id="layoutSidenav">
        <Sidebar></Sidebar>
        <div id="layoutSidenav_content">
          <div>
            <Header></Header>
          </div>
          <div id="layoutSidenav_content_body">
            <Outlet></Outlet>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Layout;
